import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-panel pw100" };
const _hoisted_2 = { class: "main-panel-content" };
const _hoisted_3 = { class: "main-panel-body pad10" };
const _hoisted_4 = { class: "clearfix pad10" };
const _hoisted_5 = { class: "card-panel left pw100" };
const _hoisted_6 = { class: "text-center" };
const _hoisted_7 = { class: "top10" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "emphasis" }, [
                                _createElementVNode("i", { class: "fa fa-android" })
                            ], -1 /* CACHED */)),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "emphasis" }, "Well, this was unexpected!", -1 /* CACHED */)),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_7, [
                                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "flow-text" }, "\r\n\t\t\t\t\t\t\t\t\tOur support team has been notified of this issue and will investigate it as soon as possible.\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "flow-text" }, "\r\n\t\t\t\t\t\t\t\t\tIn the meantime, you may wish to try the action again.\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[4] || (_cache[4] = _createTextVNode()),
                                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "flow-text" }, "\r\n\t\t\t\t\t\t\t\t\tWe apologize for any inconvenience.\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createVNode(_component_router_link, { to: { name: 'home' } }, {
                                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("a", { class: "btn btn-success white-text" }, [
                                                _createElementVNode("span", { class: "fa fa-home" }),
                                                _createTextVNode(" Home\r\n\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                })
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
